import { __assign, __rest } from "tslib";
import * as React from 'react';
import { default as MuiCheckbox } from '@material-ui/core/Checkbox';
import { CheckboxIcon } from './CheckboxIcon';
export var Checkbox = React.forwardRef(function (props, ref) {
    var disabled = props.disabled, other = __rest(props, ["disabled"]);
    return (React.createElement(MuiCheckbox, __assign({ "aria-disabled": undefined, checkedIcon: React.createElement(CheckboxIcon, { checked: true, disabled: disabled }), icon: React.createElement(CheckboxIcon, { disabled: disabled }), indeterminateIcon: React.createElement(CheckboxIcon, { indeterminate: true, disabled: disabled }), disabled: disabled, ref: ref }, other)));
});
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map